import * as React from "react";
import { useMemo } from "react";
import { useSmsSetup } from "../context";
import { ShieldCheck } from "lucide-react";
import { useSocialCoachSession } from "@/utils";

export const Stepper: React.FC = () => {
  const { step } = useSmsSetup();
  const { session } = useSocialCoachSession();

  const steps = useMemo(() => {
    const list = [];
    if (!session?.mfaVerified) {
      list.push({ key: "VERIFY_IDENTITY", label: "Security Check", desc: "Confirm your identity" });
    }
    list.push(
      { key: "ENTER_PHONE", label: "Phone Number", desc: "Add mobile number" },
      { key: "VERIFY_PHONE", label: "Verification Code", desc: "Enter 6-digit code" }
    );
    return list;
  }, [session?.mfaVerified]);

  const currentStepIndex = useMemo(() => {
    const idx = steps.findIndex(s => s.key === step);
    return idx === -1 ? 0 : idx;
  }, [steps, step]);

  return (
    <div className="w-full max-w-xl mx-auto px-4 py-2 shrink-0">
      <div className="flex items-center justify-between relative">
        {/* Connector Line */}
        <div className="absolute top-[18px] left-[10%] right-[10%] h-[2px] bg-slate-100 z-0">
          <div
            className="h-full bg-blue-500 transition-all duration-300"
            style={{ width: `${(currentStepIndex / (steps.length - 1)) * 100}%` }}
          />
        </div>

        {steps.map((s, idx) => {
          const isActive = idx === currentStepIndex;
          const isCompleted = idx < currentStepIndex;

          return (
            <div key={s.key} className="flex flex-col items-center relative z-10 select-none">
              {/* Step Circle */}
              <div
                className={`h-9 w-9 rounded-full flex items-center justify-center font-bold text-sm border-2 transition-all duration-300 ${
                  isCompleted
                    ? "bg-blue-500 border-blue-500 text-white"
                    : isActive
                    ? "bg-white border-blue-500 text-blue-600 shadow-sm shadow-blue-100"
                    : "bg-white border-slate-200 text-slate-400"
                }`}
              >
                {isCompleted ? <ShieldCheck className="h-5 w-5 stroke-[2.5]" /> : <span>{idx + 1}</span>}
              </div>
              {/* Label & Description */}
              <div className="text-center mt-2">
                <div className={`text-xs font-bold leading-none ${isActive ? "text-slate-800" : "text-slate-400"}`}>
                  {s.label}
                </div>
                <div className="text-[10px] text-slate-400 mt-1 hidden sm:block">{s.desc}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
